import React from "react";
import "./About.css";
import { Type } from "./Type";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
//import { Twitter } from "@material-ui/icons";
//import FacebookIcon from "@material-ui/icons/Facebook";
import DescriptionIcon from "@material-ui/icons/Description";
import PublicIcon from "@material-ui/icons/Public";
import { Introduction } from "./Introduction";
import { Timeline } from "./Timeline";
//import { Techstacks } from "./Techstacks";
import Resume from "../../Assets/Ruchi_Priya_Kumari_Resume.pdf";
//import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import openInNewTab from "../Navbar/newtabOpener";

export const About = () => {
  return (
    <div id="about" className="section">
      <div className="about center">
        <h1 data-aos="fade-right">
          Hi, I am <span className="about__name"  id="user-detail-name">Ruchi Priya Kumari</span>
        </h1>
        <Type />
        <p className="about__desc" data-aos="fade-right">
        An Enthusiastic Aspiring self-motivated Full Stack Web
Developer skilled in MERN stack. Highly skilled in FrontEnd , Back-End & Data Structures & algorithm. Excellent
Problem Solving-Skills and the ability to perform well in
a team. Passionate about web development , coding ,
and learning new technologies. Looking forward to
working in an organization that leads to overall growth
and development.
        </p>
        <div className="profile-options">
          {/* <button className="btn primary-btn">
            {""}
            Hire Me{" "}
          </button> */}
          {/* <button className="btn_highlighted_btn" id="resume-button-2">
          <a href={Resume} download id="resume-link-2">
          <h4 class="Resume-down">Download Resume</h4>
          </a>
          </button> */}
          <button
              id="resume-button-2"
              onClick={() =>
                openInNewTab(
                  'https:/drive.google.com/file/d/6cnSSGVz8BYM7OHiorVUtJNcpfi0/view?usp=drive'
                )
              }
              // colorScheme={'teal'}
            >
              <a href={Resume} download id='resume-link-2'>
                
                  <h4 id="col">Resume</h4>
                  {/* <Text as='span' ml={'2'}>
                    <AiOutlineDownload fontSize={'1.2rem'} />
                  </Text> */}
               
              </a>
            </button>


        </div>
        <div className="about__contact center">
          <a  id="contact-github"
            href="https://github.com/ruchipriya1009"
            aria-label="github"
            target="_blank"
            rel="noreferrer"
            className="link link--icon"
          >
            <GitHubIcon />
          </a>
          <a id="contact-email"
            href="mailto:ruchipriya1009@gmail.com"
            target="_blank"
            rel="noreferrer"
            aria-label="github"
            className="link link--icon"
          >
            <EmailIcon />
          </a>
          <a id="contact-phone"
            href="tel:+918076166383"
            target="_blank"
            rel="noreferrer"
            aria-label="github"
            className="link link--icon"
          >
            <PhoneIcon />
          </a>
          
          
          
          <a
            href="https://github.com/ruchipriya1009"
            aria-label="github"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
          >
            <PublicIcon />
          </a> 
        </div>
      </div>
      <Introduction />
      <Timeline />
      
    </div>
  );
};



// <a id="contact-linkedin"
//             href="https://www.linkedin.com/in/ruchi-priya-kumari-028593217/"
//             aria-label="github"
//             className="link link--icon"
//             target="_blank"
//             rel="noreferrer"
//           >
//             <LinkedInIcon />
//           </a>
